import { Injectable } from '@angular/core';
import {
  CountryLanguages,
  LanguageDetails
} from '../../models/utils/country-language.interfaces';
import { CountryLangHelperExtended } from './country-lang-helper-extended';
@Injectable({
  providedIn: 'root'
})
export class CountryLangExtendHelper extends CountryLangHelperExtended {
  redirectToTranslatedSites(country: string, language: string): void {
    if (this.isStopRedirection()) {
      this.getCookieValue();
    } else {
      const secondaryLanguageFlow =
        this.appconfig.getConfig('HEADER')?.['secondaryLanguageFlow'] ===
        'true';
      if (secondaryLanguageFlow) {
        this.languageRedirectionService.loadSelectedLanguage(
          country,
          language,
          this.countryLanguageList
        );
      } else {
        const appDomain = this.urlUtil.baseUrl;
        const prdENV = this.getValidDomainName(appDomain);
        const actionUrl = this.getTranslatedSite(country, language);
        const currentUrl = this.getCurrentUrl(appDomain);
        this.checkLocalHost(actionUrl, currentUrl, prdENV);
      }
    }
  }

  getCurrentUrl(appDomain: string): string {
    const res = appDomain.split('//');
    return res.length > 1 ? res[1] : res[0];
  }

  getTranslatedSite(country: string, language: string): string {
    let actionUrl = '';
    if (this.countryLanguageList && country) {
      country = country.toLowerCase(); // TODO: Add null check for country
      const languageList = this.countryLanguageList.filter((item) => {
        return item.isoCode.toLowerCase() === country; // TODO: Add null check for item.isoCode
      });
      language = language.toLowerCase();
      actionUrl = this.checkLanguageList(languageList, language);
    }
    return actionUrl;
  }

  checkLanguageList(
    languageList: CountryLanguages[],
    language: string
  ): string {
    const defaultCountry =
      this.appconfig.getConfig('HEADER')?.['APP_DEFAULT_COUNTRY'];
    let actionUrl = '';

    if (
      languageList.length > 0 &&
      languageList[0] &&
      languageList[0].languageDtls
    ) {
      const languageListItem = languageList[0];
      const reqdLanguage = languageListItem.languageDtls.filter((item) => {
        return item?.languageCode === language;
      });
      this.urlToRedirect = this.getUrlToRedirectForCDC();
      actionUrl = this.checkReqdLang(
        languageListItem,
        defaultCountry,
        reqdLanguage,
        this.urlToRedirect
      );
    }
    return actionUrl;
  }

  checkReqdLang(
    languageListItem: CountryLanguages,
    defaultCountry: string,
    reqdLanguage: LanguageDetails[],
    urlToRedirect: string
  ): string {
    if (reqdLanguage.length > 0 && reqdLanguage[0]) {
      const requiredFiteredLanguage = reqdLanguage[0];
      return this.getActionUrlForTranslatedSites(
        languageListItem,
        defaultCountry,
        requiredFiteredLanguage,
        urlToRedirect
      );
    }
    return '';
  }

  checkLocalHost(actionUrl: string, currentUrl: string, prdENV?: string): void {
    if (
      !(prdENV === 'localhost' || actionUrl === '' || currentUrl === actionUrl)
    ) {
      window.location.href = `${window.location.protocol}//${actionUrl}${this.urlToRedirect}`;
    }
  }

  getActionUrlForTranslatedSites(
    languageListItem: CountryLanguages,
    defaultCountry: string,
    requiredFiteredLanguage: LanguageDetails,
    urlToRedirect: string
  ): string {
    if (languageListItem.urlcc) {
      if (languageListItem.urlcc === defaultCountry && urlToRedirect === '') {
        return requiredFiteredLanguage.url;
      } else {
        return `${requiredFiteredLanguage.url}/${languageListItem.urlcc}/${requiredFiteredLanguage.languageCode}`;
      }
    } else {
      return requiredFiteredLanguage.url;
    }
  }

  redirectToTranslatedSitesForContentPages(
    country: string,
    language: string
  ): void {
    let actionUrl = '';
    if (this.countryLanguageList) {
      country = country.toLowerCase();
      this.languageList = this.countryLanguageList.filter((item) => {
        return item.isoCode.toLowerCase() === country;
      });
      language = language.toLowerCase();
      actionUrl = this.getReqdLangWithActionUrl(actionUrl, language);
    }
    const currentPage = window.location.href;
    const args = currentPage.split('/');
    const languageCode = args[4] ? args[4] : '';
    const returnCode = args[5] ? args[5] : '';
    const countryCode = args[3];
    actionUrl = this.finalActionUrl(
      actionUrl,
      languageCode,
      countryCode,
      returnCode,
      currentPage
    );
    window.location.href = window.location.protocol + '//' + actionUrl;
  }
}
